module.exports = __webpack_public_path__ + "static/media/Cards_Hi_Lo.01adae24.png";